/* MMG v3.9.6 · semantic media, single-video, playback, contrast, and scoped mutation safeguards */
(() => {
  'use strict';

  const clean=value=>String(value||'').replace(/\s+/g,' ').trim();
  const CCU_OVERVIEW_ID='73b835d9924a4a698d2de79322440d7a';
  const CCU_OVERVIEW_URL='https://resource2.heygen.ai/aws_pacific/avatar_tmp/ad178764af044c0ea38078421f292da0/v13c0b8c8b2aa43108d9cb3fe79540d7a/caption_73b835d9924a4a698d2de79322440d7a.mp4';
  const INJECTED_VIDEO_SURFACES='#mmg-about-brand-video,#mmg-landing-video,#mmg-knowledge-in-motion,.ccu-program-video';
  const RELEVANT_MUTATION_SELECTOR='.product-card-wrapper,.collection-card-wrapper,.article-template,video,#mmg-about-brand-video,#mmg-landing-video,#mmg-knowledge-in-motion,.ccu-program-video';

  function setAlt(img,label){
    if(!(img instanceof HTMLImageElement))return;
    if(clean(img.getAttribute('alt')))return;
    const value=clean(label);
    if(!value)return;
    img.alt=value;
    img.dataset.mmgAltFallbackV38='true';
  }

  function installCanonicalSurfaceCss(){
    if(document.getElementById('mmg-v395-surface-invariants'))return;
    const style=document.createElement('style');
    style.id='mmg-v395-surface-invariants';
    style.textContent=`
      #MainContent #mmg-about-brand-video,
      #MainContent #mmg-landing-video,
      #MainContent #mmg-knowledge-in-motion,
      #MainContent #mmg-ccu-page .mmg-ccu-page__video{color:#fff!important}
      #MainContent #mmg-about-brand-video :is(h1,h2,h3,h4,strong),
      #MainContent #mmg-landing-video :is(h1,h2,h3,h4,strong),
      #MainContent #mmg-knowledge-in-motion :is(h1,h2,h3,h4,strong),
      #MainContent #mmg-ccu-page .mmg-ccu-page__video :is(h1,h2,h3,h4,strong){color:#fff!important}
      #MainContent #mmg-about-brand-video p,
      #MainContent #mmg-landing-video p,
      #MainContent #mmg-knowledge-in-motion p,
      #MainContent #mmg-ccu-page .mmg-ccu-page__video p{color:rgba(255,255,255,.76)!important}
      #MainContent #mmg-about-brand-video :is(.mmg-about-video-kicker,.mmg-about-video-note),
      #MainContent #mmg-landing-video :is(.mmg-landing-video-kicker,.mmg-landing-video-note),
      #MainContent #mmg-knowledge-in-motion .mmg-kim__eyebrow{color:#8ab4ff!important}
      #MainContent #mmg-knowledge-in-motion .mmg-kim__video-card{border-color:rgba(255,255,255,.13)!important;background:linear-gradient(180deg,rgba(255,255,255,.075),rgba(255,255,255,.025))!important;color:#fff!important;box-shadow:0 28px 70px rgba(0,0,0,.42)!important}
      #MainContent #mmg-knowledge-in-motion .mmg-kim__caption{color:rgba(255,255,255,.62)!important}
      #MainContent #mmg-knowledge-in-motion .mmg-kim__caption strong{color:rgba(255,255,255,.92)!important}
      #MainContent article.card,
      #MainContent article.mmg-card:not(.mmg-auth-card){border-color:rgba(15,23,42,.08)!important;background:#fff!important;color:#0f172a!important}
      #MainContent article.card :is(h2,h3,h4,strong),
      #MainContent article.mmg-card:not(.mmg-auth-card) :is(h2,h3,h4,strong){color:#0f172a!important}
      #MainContent article.card :is(p,li),
      #MainContent article.mmg-card:not(.mmg-auth-card) :is(p,li){color:#64748b!important}
    `;
    document.head.appendChild(style);
  }

  function repairCreatorOverview(root=document){
    const video=root.querySelector?.(`#mmg-ccu-page [data-heygen-video-id="${CCU_OVERVIEW_ID}"] video,#mmg-ccu-page .mmg-ccu-page__video video`);
    if(!(video instanceof HTMLVideoElement))return;
    let source=video.querySelector('source[type="video/mp4"],source');
    if(!source){
      source=document.createElement('source');
      source.type='video/mp4';
      video.appendChild(source);
    }
    const current=source.getAttribute('src')||video.getAttribute('src')||'';
    if(current!==CCU_OVERVIEW_URL){
      source.setAttribute('src',CCU_OVERVIEW_URL);
      video.removeAttribute('src');
      video.load();
      video.dataset.mmgCcuOverviewRepair='stable-captioned-master';
    }
    video.controls=true;
    video.setAttribute('playsinline','');
    video.setAttribute('preload','metadata');
  }

  function chooseCanonicalVideo(main,videos){
    const priorities=[
      '#mmg-ccu-page .mmg-ccu-page__video video',
      '#mmg-ai-image-mastery video',
      '#mmg-about-v320 section[aria-labelledby="mmg-about-video-title"] video',
      '#mmg-digital-assets-v642 section[aria-labelledby="mmg-assets-video-title"] video',
      '#mmg-professional-services-v1 section[aria-labelledby="mmg-services-video-title"] video',
      '[data-mmg-video-owner="true"] video'
    ];
    for(const selector of priorities){
      const match=main.querySelector(selector);
      if(match&&videos.includes(match))return match;
    }
    return videos.find(video=>!video.closest(INJECTED_VIDEO_SURFACES))||videos[0]||null;
  }

  function removeDuplicateVideo(video,owner){
    if(!(video instanceof HTMLVideoElement)||video===owner)return;
    const injected=video.closest(INJECTED_VIDEO_SURFACES);
    if(injected&&!injected.contains(owner)){
      injected.remove();
      return;
    }
    const section=video.closest('section');
    if(section&&!section.contains(owner)&&section.querySelectorAll('video').length===1){
      const signature=`${section.id||''} ${section.className||''} ${section.getAttribute('aria-label')||''} ${section.getAttribute('aria-labelledby')||''}`.toLowerCase();
      if(signature.includes('video')){
        section.remove();
        return;
      }
    }
    const frame=video.parentElement;
    video.remove();
    if(frame&&frame.isConnected&&!frame.querySelector('video')&&/video/i.test(String(frame.className||'')))frame.hidden=true;
  }

  function enforceSingleVideo(root=document){
    const main=root.querySelector?.('#MainContent')||document.getElementById('MainContent');
    if(!main)return;
    const videos=[...main.querySelectorAll('video')];
    if(videos.length<=1){
      main.dataset.mmgVideoCount=String(videos.length);
      main.dataset.mmgVideoGovernance='single-owner';
      return;
    }
    const owner=chooseCanonicalVideo(main,videos);
    videos.forEach(video=>removeDuplicateVideo(video,owner));
    const remaining=main.querySelectorAll('video').length;
    main.dataset.mmgVideoCount=String(remaining);
    main.dataset.mmgVideoDuplicatesRemoved=String(Math.max(0,videos.length-remaining));
    main.dataset.mmgVideoGovernance=remaining<=1?'single-owner':'review-required';
  }

  function apply(root=document){
    installCanonicalSurfaceCss();
    root.querySelectorAll?.('a[href="https://www.tiktok.com/mindset.media.group"],a[href="https://tiktok.com/mindset.media.group"]').forEach(anchor=>{anchor.href='https://www.tiktok.com/@mindset.media.group';anchor.dataset.mmgSocialCanonicalV38='true'});
    root.querySelectorAll?.('.product-card-wrapper').forEach(card=>{const title=clean(card.querySelector('.card__heading a, .card__heading')?.textContent);card.querySelectorAll('img').forEach(img=>{setAlt(img,title?`${title} product image`:'');if(!img.decoding)img.decoding='async'})});
    root.querySelectorAll?.('.collection-card-wrapper').forEach(card=>{const title=clean(card.querySelector('.card__heading a, .card__heading')?.textContent);card.querySelectorAll('img').forEach(img=>{setAlt(img,title?`${title} collection image`:'');if(!img.decoding)img.decoding='async'})});
    root.querySelectorAll?.('.article-template').forEach(article=>{const title=clean(article.querySelector('h1')?.textContent);article.querySelectorAll('.article-template__hero-container img').forEach(img=>setAlt(img,title))});
    repairCreatorOverview(document);
    enforceSingleVideo(document);
  }

  let queued=false;
  const schedule=()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;apply(document)});
  };

  function relevantNode(node){
    if(!(node instanceof Element))return false;
    return node.matches(RELEVANT_MUTATION_SELECTOR)||!!node.querySelector?.(RELEVANT_MUTATION_SELECTOR);
  }

  function init(){
    document.documentElement.dataset.mmgSeoA11y='v396-scoped-runtime';
    apply(document);
    document.addEventListener('shopify:section:load',schedule);
    window.addEventListener('pageshow',schedule);
    const main=document.getElementById('MainContent');
    if('MutationObserver'in window&&main){
      new MutationObserver(ms=>{
        if(ms.some(m=>[...m.addedNodes,...m.removedNodes].some(relevantNode)))schedule();
      }).observe(main,{childList:true,subtree:true});
    }
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
